import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.map";
import "core-js/modules/es7.object.values";
import "core-js/modules/es6.date.now";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[typeof Symbol === "function" ? Symbol.iterator : "@@iterator"]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import Hammer from '@egjs/hammerjs';
import findNodeHandle from "react-native-web/dist/exports/findNodeHandle";
import State from "../State";
import { EventMap } from "./constants";
import * as NodeManager from "./NodeManager";
var _gestureInstances = 0;

var GestureHandler = function () {
  _createClass(GestureHandler, [{
    key: "id",
    get: function get() {
      return "" + this.name + this._gestureInstance;
    }
  }, {
    key: "isDiscrete",
    get: function get() {
      return false;
    }
  }, {
    key: "shouldEnableGestureOnSetup",
    get: function get() {
      throw new Error('Must override GestureHandler.shouldEnableGestureOnSetup');
    }
  }]);

  function GestureHandler() {
    var _this = this;

    _classCallCheck(this, GestureHandler);

    this.isGestureRunning = false;
    this.hasGestureFailed = false;
    this.view = null;
    this.config = {};
    this.hammer = null;
    this.pendingGestures = {};
    this.oldState = State.UNDETERMINED;
    this.previousState = State.UNDETERMINED;
    this.lastSentState = null;

    this.clearSelfAsPending = function () {
      if (Array.isArray(_this.config.waitFor)) {
        for (var _iterator = _createForOfIteratorHelperLoose(_this.config.waitFor), _step; !(_step = _iterator()).done;) {
          var gesture = _step.value;
          gesture.removePendingGesture(_this.id);
        }
      }
    };

    this.destroy = function () {
      _this.clearSelfAsPending();

      if (_this.hammer) {
        _this.hammer.stop();

        _this.hammer.destroy();
      }

      _this.hammer = null;
    };

    this.isPointInView = function (_ref) {
      var x = _ref.x,
          y = _ref.y;

      var rect = _this.view.getBoundingClientRect();

      var pointerInside = x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
      return pointerInside;
    };

    this.sendEvent = function (nativeEvent) {
      var _this$ref$props = _this.ref.props,
          onHandlerStateChange = _this$ref$props.onGestureHandlerStateChange,
          onGestureEvent = _this$ref$props.onGestureHandlerEvent;

      var event = _this.transformEventData(nativeEvent);

      invokeNullableMethod('onGestureEvent', onGestureEvent, event);

      if (_this.lastSentState !== event.nativeEvent.state) {
        _this.lastSentState = event.nativeEvent.state;
        invokeNullableMethod('onHandlerStateChange', onHandlerStateChange, event);
      }
    };

    this.sync = function () {
      var gesture = _this.hammer.get(_this.name);

      if (!gesture) return;

      var enable = function enable(recognizer, inputData) {
        if (!_this.config.enabled) {
          _this.isGestureRunning = false;
          _this.hasGestureFailed = false;
          return false;
        }

        if (!inputData || !recognizer.options || typeof inputData.maxPointers === 'undefined') {
          return _this.shouldEnableGestureOnSetup;
        }

        if (_this.hasGestureFailed) {
          return false;
        }

        if (!_this.isDiscrete) {
          if (_this.isGestureRunning) {
            return true;
          }

          _this._stillWaiting = _this._getPendingGestures();

          if (_this._stillWaiting.length) {
            for (var _iterator2 = _createForOfIteratorHelperLoose(_this._stillWaiting), _step2; !(_step2 = _iterator2()).done;) {
              var _gesture = _step2.value;

              if (!_gesture.isDiscrete && _gesture.isGestureRunning) {
                _this.hasGestureFailed = true;
                _this.isGestureRunning = false;
                return false;
              }
            }

            return false;
          }
        }

        if (!_this._hasCustomActivationCriteria) {
          return true;
        }

        var deltaRotation = _this.initialRotation == null ? 0 : inputData.rotation - _this.initialRotation;

        var _this$isGestureEnable = _this.isGestureEnabledForEvent(_this.getConfig(), recognizer, _objectSpread(_objectSpread({}, inputData), {}, {
          deltaRotation: deltaRotation
        })),
            success = _this$isGestureEnable.success,
            failed = _this$isGestureEnable.failed;

        if (failed) {
          _this.simulateCancelEvent(inputData);

          _this.hasGestureFailed = true;
        }

        return success;
      };

      var params = _this.getHammerConfig();

      gesture.set(_objectSpread(_objectSpread({}, params), {}, {
        enable: enable
      }));
    };

    this._gestureInstance = _gestureInstances++;
  }

  _createClass(GestureHandler, [{
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "onWaitingEnded",
    value: function onWaitingEnded(gesture) {}
  }, {
    key: "removePendingGesture",
    value: function removePendingGesture(id) {
      delete this.pendingGestures[id];
    }
  }, {
    key: "addPendingGesture",
    value: function addPendingGesture(gesture) {
      this.pendingGestures[gesture.id] = gesture;
    }
  }, {
    key: "isGestureEnabledForEvent",
    value: function isGestureEnabledForEvent() {
      return {
        success: true
      };
    }
  }, {
    key: "parseNativeEvent",
    value: function parseNativeEvent(nativeEvent) {
      return nativeEvent;
    }
  }, {
    key: "updateHasCustomActivationCriteria",
    value: function updateHasCustomActivationCriteria(config) {
      return true;
    }
  }, {
    key: "updateGestureConfig",
    value: function updateGestureConfig(_ref2) {
      var _ref2$enabled = _ref2.enabled,
          enabled = _ref2$enabled === void 0 ? true : _ref2$enabled,
          props = _objectWithoutProperties(_ref2, ["enabled"]);

      this.clearSelfAsPending();
      this.config = ensureConfig(_objectSpread({
        enabled: enabled
      }, props));
      this._hasCustomActivationCriteria = this.updateHasCustomActivationCriteria(this.config);

      if (Array.isArray(this.config.waitFor)) {
        for (var _iterator3 = _createForOfIteratorHelperLoose(this.config.waitFor), _step3; !(_step3 = _iterator3()).done;) {
          var gesture = _step3.value;
          gesture.addPendingGesture(this);
        }
      }

      if (this.hammer) {
        this.sync();
      }

      return this.config;
    }
  }, {
    key: "getState",
    value: function getState(type) {
      return EventMap[type];
    }
  }, {
    key: "transformEventData",
    value: function transformEventData(event) {
      var eventType = event.eventType,
          numberOfPointers = event.maxPointers;
      var changedTouch = event.changedPointers[0];
      var pointerInside = this.isPointInView({
        x: changedTouch.clientX,
        y: changedTouch.clientY
      });
      var state = this.getState(eventType);

      if (state !== this.previousState) {
        this.oldState = this.previousState;
        this.previousState = state;
      }

      return {
        nativeEvent: _objectSpread(_objectSpread({
          numberOfPointers: numberOfPointers,
          state: state,
          pointerInside: pointerInside
        }, this.transformNativeEvent(event)), {}, {
          handlerTag: this.handlerTag,
          target: this.ref,
          oldState: this.oldState
        }),
        timeStamp: Date.now()
      };
    }
  }, {
    key: "transformNativeEvent",
    value: function transformNativeEvent(event) {
      return {};
    }
  }, {
    key: "cancelPendingGestures",
    value: function cancelPendingGestures(event) {
      for (var _i = 0, _Object$values = Object.values(this.pendingGestures); _i < _Object$values.length; _i++) {
        var gesture = _Object$values[_i];

        if (gesture && gesture.isGestureRunning) {
          gesture.hasGestureFailed = true;
          gesture.cancelEvent(event);
        }
      }
    }
  }, {
    key: "notifyPendingGestures",
    value: function notifyPendingGestures() {
      for (var _i2 = 0, _Object$values2 = Object.values(this.pendingGestures); _i2 < _Object$values2.length; _i2++) {
        var gesture = _Object$values2[_i2];

        if (gesture) {
          gesture.onWaitingEnded(this);
        }
      }
    }
  }, {
    key: "onGestureEnded",
    value: function onGestureEnded(event) {
      this.isGestureRunning = false;
      this.cancelPendingGestures(event);
    }
  }, {
    key: "forceInvalidate",
    value: function forceInvalidate(event) {
      if (this.isGestureRunning) {
        this.hasGestureFailed = true;
        this.cancelEvent(event);
      }
    }
  }, {
    key: "cancelEvent",
    value: function cancelEvent(event) {
      this.notifyPendingGestures();
      this.sendEvent(_objectSpread(_objectSpread({}, event), {}, {
        eventType: Hammer.INPUT_CANCEL,
        isFinal: true
      }));
      this.onGestureEnded(event);
    }
  }, {
    key: "onRawEvent",
    value: function onRawEvent(_ref3) {
      var isFirst = _ref3.isFirst;

      if (isFirst) {
        this.hasGestureFailed = false;
      }
    }
  }, {
    key: "setView",
    value: function setView(ref) {
      var _this2 = this;

      if (ref == null) {
        this.destroy();
        this.view = null;
        return;
      }

      this.ref = ref;
      this.view = findNodeHandle(ref);
      this.hammer = new Hammer.Manager(this.view);
      this.oldState = State.UNDETERMINED;
      this.previousState = State.UNDETERMINED;
      this.lastSentState = null;
      var NativeGestureClass = this.NativeGestureClass;
      var gesture = new NativeGestureClass(this.getHammerConfig());
      this.hammer.add(gesture);
      this.hammer.on('hammer.input', function (ev) {
        if (!_this2.config.enabled) {
          _this2.hasGestureFailed = false;
          _this2.isGestureRunning = false;
          return;
        }

        _this2.onRawEvent(ev);

        if (_this2.initialRotation === null && ev.rotation !== 0) {
          _this2.initialRotation = ev.rotation;
        }

        if (ev.isFinal) {
          setTimeout(function () {
            _this2.initialRotation = null;
            _this2.hasGestureFailed = false;
          });
        }
      });
      this.setupEvents();
      this.sync();
    }
  }, {
    key: "setupEvents",
    value: function setupEvents() {
      var _this3 = this;

      if (!this.isDiscrete) {
        this.hammer.on(this.name + "start", function (event) {
          return _this3.onStart(event);
        });
        this.hammer.on(this.name + "end " + this.name + "cancel", function (event) {
          return _this3.onGestureEnded(event);
        });
      }

      this.hammer.on(this.name, function (ev) {
        return _this3.onGestureActivated(ev);
      });
    }
  }, {
    key: "onStart",
    value: function onStart(_ref4) {
      var deltaX = _ref4.deltaX,
          deltaY = _ref4.deltaY,
          rotation = _ref4.rotation;
      this.oldState = State.UNDETERMINED;
      this.previousState = State.UNDETERMINED;
      this.lastSentState = null;
      this.isGestureRunning = true;
      this.__initialX = deltaX;
      this.__initialY = deltaY;
      this.initialRotation = rotation;
    }
  }, {
    key: "onGestureActivated",
    value: function onGestureActivated(ev) {
      this.sendEvent(ev);
    }
  }, {
    key: "onSuccess",
    value: function onSuccess() {}
  }, {
    key: "_getPendingGestures",
    value: function _getPendingGestures() {
      if (Array.isArray(this.config.waitFor) && this.config.waitFor.length) {
        var stillWaiting = this.config.waitFor.filter(function (_ref5) {
          var hasGestureFailed = _ref5.hasGestureFailed;
          return hasGestureFailed === false;
        });
        return stillWaiting;
      }

      return [];
    }
  }, {
    key: "getHammerConfig",
    value: function getHammerConfig() {
      var pointers = this.config.minPointers === this.config.maxPointers ? this.config.minPointers : 0;
      return {
        pointers: pointers
      };
    }
  }, {
    key: "simulateCancelEvent",
    value: function simulateCancelEvent(inputData) {}
  }, {
    key: "NativeGestureClass",
    get: function get() {
      throw new Error('Must override GestureHandler.NativeGestureClass');
    }
  }]);

  return GestureHandler;
}();

function invokeNullableMethod(name, method, event) {
  if (method) {
    if (typeof method === 'function') {
      method(event);
    } else {
      if ('__getHandler' in method && typeof method.__getHandler === 'function') {
        var handler = method.__getHandler();

        invokeNullableMethod(name, handler, event);
      } else {
        if ('__nodeConfig' in method) {
          var argMapping = method.__nodeConfig.argMapping;

          if (Array.isArray(argMapping)) {
            for (var index in argMapping) {
              var _argMapping$index = _slicedToArray(argMapping[index], 2),
                  key = _argMapping$index[0],
                  value = _argMapping$index[1];

              if (key in event.nativeEvent) {
                var nativeValue = event.nativeEvent[key];

                if (value && value.setValue) {
                  value.setValue(nativeValue);
                } else {
                  method.__nodeConfig.argMapping[index] = [key, nativeValue];
                }
              }
            }
          }
        }
      }
    }
  }
}

function ensureConfig(config) {
  var props = _objectSpread({}, config);

  if ('minDist' in config) {
    props.minDist = config.minDist;
    props.minDistSq = props.minDist * props.minDist;
  }

  if ('minVelocity' in config) {
    props.minVelocity = config.minVelocity;
    props.minVelocitySq = props.minVelocity * props.minVelocity;
  }

  if ('maxDist' in config) {
    props.maxDist = config.maxDist;
    props.maxDistSq = config.maxDist * config.maxDist;
  }

  if ('waitFor' in config) {
    props.waitFor = asArray(config.waitFor).map(function (_ref6) {
      var _handlerTag = _ref6._handlerTag;
      return NodeManager.getHandler(_handlerTag);
    }).filter(function (v) {
      return v;
    });
  } else {
    props.waitFor = null;
  }

  ['minPointers', 'maxPointers', 'minDist', 'maxDist', 'maxDistSq', 'minVelocitySq', 'minDistSq', 'minVelocity', 'failOffsetXStart', 'failOffsetYStart', 'failOffsetXEnd', 'failOffsetYEnd', 'activeOffsetXStart', 'activeOffsetXEnd', 'activeOffsetYStart', 'activeOffsetYEnd'].forEach(function (prop) {
    if (typeof props[prop] === 'undefined') {
      props[prop] = Number.NaN;
    }
  });
  return props;
}

function asArray(value) {
  return value == null ? [] : Array.isArray(value) ? value : [value];
}

export default GestureHandler;